const invoicingFilters = {
  invoiceFrequencyId: null,
  dateBegin: null,
  dateEnd: null,
  showDetails: false
}

export default () => Object.assign({}, invoicingFilters)
